const Item = ({
  children,
  width,
  height,
}: {
  children?: React.ReactNode;
  width: number;
  height: number;
}) => {
  return (
    <div
      className="flex flex-col items-center justify-center shrink-0"
      style={{ width, height }}
    >
      {children}
    </div>
  );
};

export default Item;
